import { XIcon } from '@langchain/untitled-ui-icons';

import { useState } from 'react';

import DeleteConfirmationModal from '@/components/DeleteConfirmationModal';
import useToast from '@/components/Toast/useToast';
import { Tooltip } from '@/design-system';

export const RemoveReferenceOutputButton = ({
  setIsReferenceOutputHidden,
  onRemoveReferenceOutput,
}: {
  setIsReferenceOutputHidden: (hidden: boolean) => void;
  onRemoveReferenceOutput?: () => void;
}) => {
  const { createToast } = useToast();
  const [isConfirmRemoveModalOpen, setIsConfirmRemoveModalOpen] =
    useState(false);
  const [removeTimeoutId, setRemoveTimeoutId] = useState<NodeJS.Timeout>();

  const removeReferenceOutputWithUndo = () => {
    setIsReferenceOutputHidden(true);

    // Clear any existing timeout
    if (removeTimeoutId) {
      clearTimeout(removeTimeoutId);
    }

    // Set new timeout
    const timeoutId = setTimeout(() => {
      onRemoveReferenceOutput?.();
    }, 5000);

    setRemoveTimeoutId(timeoutId);

    createToast({
      title: 'Reference output removed from dataset',
      description: (
        <button
          type="button"
          onClick={() => {
            setIsReferenceOutputHidden(false);
            if (removeTimeoutId) {
              clearTimeout(removeTimeoutId);
            }
          }}
          className="underline"
        >
          Undo
        </button>
      ),
    });
  };

  return (
    <>
      <Tooltip
        title="Remove Reference Output"
        description="Remove if your example doesn't need a reference to compare actual & expected results."
        tooltipClassName="flex items-center"
      >
        <button
          type="button"
          onClick={() => setIsConfirmRemoveModalOpen(true)}
          className="rounded-md p-[1px] hover:bg-quaternary"
        >
          <XIcon className="h-4 w-4 text-secondary" />
        </button>
      </Tooltip>
      <DeleteConfirmationModal
        isOpen={isConfirmRemoveModalOpen}
        onClose={() => setIsConfirmRemoveModalOpen(false)}
        onConfirm={removeReferenceOutputWithUndo}
        title="Remove Reference Output?"
        description="Removing the reference output will create a reference-free dataset. This will remove the reference output from all examples."
      />
    </>
  );
};
